// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportsBalanceBlock_wrapper__++Pd4"};